module.exports = __webpack_public_path__ + "media/images/member/profile-976c121329618f239ce45a0d1eb6afba.png";